export const DEFAULT_SUPER_ADMIN_COMPANY = 'TOCG';

export function findCompanyIdByName(companies, name = DEFAULT_SUPER_ADMIN_COMPANY) {
  const match = (companies || []).find(
    (company) => company.name?.trim().toUpperCase() === name.trim().toUpperCase()
  );
  return match ? String(match.id) : '';
}
